/**
 * Resolve a media URL for use with NuxtImg.
 * - Local paths (/) → use as-is with Cloudflare provider
 * - Full URLs (http) → pass through directly
 * - Relative paths → resolve via the media helper
 */
export function resolveMediaUrl(url: string, getContentMediaUrl: (url?: string) => string | undefined): string | undefined {
    if (url.startsWith('/')) return url
    if (url.startsWith('http')) return url
    return getContentMediaUrl(url)
}

export function isLocalMedia(url: string): boolean {
    return url.startsWith('/')
}
